import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Chip from '@mui/material/Chip';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDateRangePicker } from '@mui/x-date-pickers-pro/StaticDateRangePicker';
import { Divider, Box } from '@mui/material';
import Fab from '@mui/material/Fab';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import './DatePickerDropdown.css';
import { Tooltip } from '@mui/material';
const shortcutsItems = [
    {
        label: 'This Week',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('week'), today.endOf('week')];
        },
    },
    {
        label: 'Last Week',
        getValue: () => {
            const today = dayjs();
            const prevWeek = today.subtract(7, 'day');
            return [prevWeek.startOf('week'), prevWeek.endOf('week')];
        },
    },
    {
        label: 'Last 7 Days',
        getValue: () => {
            const today = dayjs();
            return [today.subtract(7, 'day'), today];
        },
    },
    {
        label: 'Current Month',
        getValue: () => {
            const today = dayjs();
            return [today.startOf('month'), today.endOf('month')];
        },
    },
    {
        label: 'Last Month',
        getValue: () => {
            const today = dayjs();
            const startOfPrevMonth = today.startOf('month').add(-1, 'day').startOf('month');;
            return [startOfPrevMonth, startOfPrevMonth.endOf('month')];
        },
    },
    {
        label: 'This Year',
        getValue: () => {
            const today = dayjs();
            const start = today.startOf('year');
            return [start, today];
        },
    },
    {
        label: 'Last Year',
        getValue: () => {
            const today = dayjs();
            const start = today.startOf('year').add(-1, 'year');
            return [start, start.add(1, 'year')];
        },
    },
    { label: 'Reset', getValue: () => [null, null] },
];

function CustomRangeShortcuts(props) {
    const { items, onChange, isValid } = props;

    if (items == null || items.length === 0) {
        return null;
    }

    const resolvedItems = items.map((item) => {
        const newValue = item.getValue({ isValid });

        return {
            label: item.label,
            onClick: () => {
                onChange(newValue);
            },
            disabled: !isValid(newValue),
        };
    });

    return (
        <Box
            sx={{
                gridRow: 1,
                gridColumn: 2,
            }}
        >

            <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '85vw' } }
                    sx={(theme) => ({
                    display: 'flex',
                    px: theme.spacing(4),
                    '& .MuiListItem-root': {
                        pt: 0,
                        pl: 0,
                        pr: theme.spacing(1),
                    },
                })}
            >
                {resolvedItems.map((item) => {
                    return (
                        <Chip {...item} />
                    );
                })}
            </div>
            <Divider />
        </Box>
    );

    return (
        <Box
            sx={{
                gridRow: 1,
                gridColumn: 2,
            }}
        >
            
            <List
                dense
                sx={(theme) => ({
                    display: 'flex',
                    px: theme.spacing(4),
                    '& .MuiListItem-root': {
                        pt: 0,
                        pl: 0,
                        pr: theme.spacing(1),
                    },
                })}
            >
                {resolvedItems.map((item) => {
                    return (
                        <ListItem key={item.label}>
                            <Chip {...item} />
                        </ListItem>
                    );
                })}
            </List>
            <Divider />
        </Box>
    );
}

export default function DatePickerDropdown(props) {

    const [isExpanded, setIsExpanded] = React.useState(false);
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    function handleDateChanged(a, b, c, d) {
        console.clear();
        
        if (a != null) {
            if (a.length == 2) {
                setStartDate(a[0]);
                setEndDate(a[1]);
            }
        }
    }

    function handleCancel() {
        setIsExpanded(false);
    }

    function handleAccept(event) {
        if (props.onDateSelected !== undefined) {
            props.onDateSelected(startDate, endDate);
        }
        setIsExpanded(false);
    }

    return (<>
        {props.tooltipText == undefined ?

            <Fab size='small' style={{ backgroundColor: 'var(--sipzee-blue-1)', color: 'var(--sipzee-gray)' }} onClick={() => setIsExpanded(!isExpanded)}><CalendarMonthIcon /></Fab>
            :
            <Tooltip title={props.tooltipText }>
                <Fab size='small' style={{ backgroundColor: 'var(--sipzee-blue-1)', color: 'var(--sipzee-gray)' }} onClick={() => setIsExpanded(!isExpanded)}><CalendarMonthIcon /></Fab>
            </Tooltip>
        }

        {!isExpanded ? null

            :

            <Dialog onClose={() => setIsExpanded(false)} open={isExpanded}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "700px",  // Set your width here
                        },
                    },
                }}>
                <DialogTitle>Date Range</DialogTitle>
                <LocalizationProvider dateAdapter={AdapterDayjs}>

                    <StaticDateRangePicker
                        className={'datePicker'}
                        onChange={handleDateChanged}
                        slots={{
                            shortcuts: CustomRangeShortcuts,
                        }}
                        slotProps={{
                            shortcuts: {
                                items: shortcutsItems,
                            },
                            toolbar: {
                                hidden: true,
                            },
                            actionbar: {

                                actionbar: { actions: ['clear'] },
                            },

                        }}
                        calendars={2}
                    />
                </LocalizationProvider>
                <DialogActions>
                    <Button autoFocus onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button disabled={startDate == null || endDate == null} onClick={handleAccept}>Accept</Button>
                </DialogActions>
            </Dialog>
        }
    </>
    );
    
}